export class JumpToAnchor {
  constructor (settings = {}) {
    this.options = $.extend({
      selectors: {
        toTop: '.btn--to-top, .btn--to-top-fixed',
        anchor: 'a[href*="#"][href*="' + window.location.host + '"],a[href^="/"][href*="#"]:not([href^="//"])',
        pageHeader: '.page-header'
      },
      classes: {
        bodyHeaderScrolling: 'is--header-scrolling',
        bodyOnScrolling: 'is--btn-to-top'
      },
      scrollTime: 2000,
      additionalOffsetTop: 10,
      ticking: false,
      scrollBreakpoint: 0.9
    },
    settings)
  }

  init () {
    this.addEvents()
  }

  addEvents () {
    const that = this

    $(that.options.selectors.toTop)
      .on({
        click: function (event) {
          event.preventDefault()

          that.jumpToTop()
        }
      })

    $(that.options.selectors.anchor)
      .on({
        click: function (event) {
          const element = $(this)
          const hash = element.attr('href').substring(element.attr('href').indexOf('#'))

          if (hash.length > 1) {
            const targetElement = $(hash)

            if (targetElement.length > 0 && targetElement.is(':visible')) {
              event.preventDefault()

              that.jumpToElement(targetElement)
            }
          }
        }
      })

    that.addIsHeaderScrolling(window.scrollY)
    $(document).on('scroll', function () {
      const lastKnowScrollPosition = window.scrollY

      if (!that.ticking) {
        window.requestAnimationFrame(function () {
          that.addIsHeaderScrolling(lastKnowScrollPosition)
          that.ticking = false
        })
      }

      that.ticking = true
    })
  }

  jumpToTop () {
    const that = this

    $('html, body')
      .animate({
        scrollTop: 0
      }, that.options.scrollTime)
  }

  jumpToElement (element) {
    const that = this

    if (element.length) {
      $('html, body')
        .animate({
          scrollTop: element.offset().top - that.calculateHeaderOffset()
        }, that.options.scrollTime)
    }
  }

  calculateHeaderOffset () {
    const that = this

    if ($('body').hasClass(that.options.classes.bodyHeaderScrolling) && $(that.options.selectors.pageHeader).length > 0) {
      return $(that.options.selectors.pageHeader).outerHeight() + that.options.additionalOffsetTop
    }

    return 0
  }

  addIsHeaderScrolling (scrollPosition) {
    const halfTheScreenHeight = window.innerHeight / this.options.scrollBreakpoint
    const scrollTillEnd = (($(document).height() - $(window).innerHeight()) - scrollPosition)

    if (scrollPosition >= halfTheScreenHeight) {
      if (scrollTillEnd > 250) {
        $('body').addClass(this.options.classes.bodyOnScrolling)
      } else if (scrollTillEnd < 150) {
        $('body').removeClass(this.options.classes.bodyOnScrolling)
      }
    } else {
      $('body').removeClass(this.options.classes.bodyOnScrolling)
    }
  }
}

export default JumpToAnchor
